import request, { REQUEST_METHODS } from '@api/Request';
import { AorEndpoints } from './config';
import {
  GeoJson,
  GetRegulatoryAorLayerResponse,
  GetDistrictFromGeometryResponse,
  GetAreaNameFromGeometryResponse,
} from './types';
import { convertGeoJsonToEsri, convertGeoJsonTypeToEsri } from './helpers';

const commonPostData = {
  f: 'json',
  inSR: 4326,
  returnDistinctValues: true,
  returnGeometry: false,
  where: '1=1',
};
const timeout = 10 * 1000; // 10 seconds

const buildFormData = (data: Record<string, unknown>): FormData => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => formData.append(key, String(value)));
  return formData;
};

export default class AorService {
  public static readonly getRegulatoryAorLayer = async (geoJson: GeoJson): Promise<GetRegulatoryAorLayerResponse> => {
    const geometry = convertGeoJsonToEsri(geoJson);
    const geometryType = convertGeoJsonTypeToEsri(geoJson?.type);

    return request({
      url: AorEndpoints.getRegulatoryAorLayer(),
      method: REQUEST_METHODS.POST,
      timeout,
      data: buildFormData({
        geometry,
        geometryType,
        outFields: 'OBJECTID',
        spatialRel: 'esriSpatialRelWithin',
        ...commonPostData,
      }),
    });
  };

  public static readonly getDistrictLocationFromGeometry = async (
    geoJson: GeoJson
  ): Promise<GetDistrictFromGeometryResponse> => {
    const geometry = convertGeoJsonToEsri(geoJson);
    const geometryType = convertGeoJsonTypeToEsri(geoJson?.type);

    return request({
      url: AorEndpoints.getStateEezDistrictBoundaries(),
      method: REQUEST_METHODS.POST,
      timeout,
      data: buildFormData({
        geometry,
        geometryType,
        outFields: 'DISTRICT,STUSPS',
        spatialRel: 'esriSpatialRelIntersects',
        ...commonPostData,
      }),
    });
  };

  public static readonly getAreaNameFromGeometry = async (
    geometry: GeoJson
  ): Promise<GetAreaNameFromGeometryResponse> => {
    const esriGeometry = convertGeoJsonToEsri(geometry);
    const geometryType = convertGeoJsonTypeToEsri(geometry?.type);

    return request({
      url: AorEndpoints.getRegulatoryAorEezLayer(),
      method: REQUEST_METHODS.POST,
      timeout,
      data: buildFormData({
        geometry: esriGeometry,
        geometryType,
        outFields: 'AREANAME',
        spatialRel: 'esriSpatialRelIntersects',
        ...commonPostData,
      }),
    });
  };
}
